import getLocalString from "constants/Localization";
import { useGetReportSalesByContactMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportSalesByContact = (showSuccessMessage: boolean = true) => {
  const [mutation, { loading, data, error }] = useGetReportSalesByContactMutation();
  const [getReportSalesByContact, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportSalesByContact",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportSalesByContact, { ...context, data }] as const;
};

export default useGetReportSalesByContact;
